export { default } from './BlogPostsLoading';